import Alpine from 'alpinejs';
import persist from "@alpinejs/persist";
import multiRangeSlider from "./alpine-plugins/multi-range-slider";

window.Alpine = Alpine;
Alpine.plugin(persist);
Alpine.plugin(multiRangeSlider);

document.addEventListener('DOMContentLoaded', () => {
    Alpine.start();
});
